import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-6" }
const _hoisted_3 = { class: "card mb-25 border-0 rounded-0 bg-white add-product-box" }
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_5 = { class: "list-unstyled my-1" }
const _hoisted_6 = { class: "my-25" }
const _hoisted_7 = { class: "align-middle" }
const _hoisted_8 = { class: "my-25" }
const _hoisted_9 = { class: "align-middle" }
const _hoisted_10 = { class: "align-middle" }
const _hoisted_11 = { class: "col-md-6" }
const _hoisted_12 = { class: "card mb-25 border-0 rounded-0 bg-white add-product-box" }
const _hoisted_13 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_14 = { class: "list-unstyled my-1" }
const _hoisted_15 = { class: "align-middle" }
const _hoisted_16 = { class: "my-25" }
const _hoisted_17 = { class: "align-middle" }
const _hoisted_18 = { class: "align-middle" }
const _hoisted_19 = { class: "align-middle" }
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "col-md-6" }
const _hoisted_22 = { class: "custom-search d-flex justify-content-end" }
const _hoisted_23 = { class: "form-group" }
const _hoisted_24 = { class: "d-flex align-items-center" }
const _hoisted_25 = {
  key: 0,
  class: "text-nowrap"
}
const _hoisted_26 = { class: "text-nowrap" }
const _hoisted_27 = { key: 1 }
const _hoisted_28 = { key: 2 }
const _hoisted_29 = { key: 3 }
const _hoisted_30 = { key: 4 }
const _hoisted_31 = { key: 5 }
const _hoisted_32 = { key: 6 }
const _hoisted_33 = { class: "d-flex justify-content-end mb-2" }
const _hoisted_34 = { class: "fs-5" }
const _hoisted_35 = { class: "row" }
const _hoisted_36 = { class: "col-md-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_feather_icon = _resolveComponent("feather-icon")!
  const _component_buttonn = _resolveComponent("buttonn")!
  const _component_vue_good_table = _resolveComponent("vue-good-table")!
  const _component_PaginatorContent = _resolveComponent("PaginatorContent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "card-header" }, [
            _createElementVNode("h5", { class: "mb-0" }, "Informarion Client :")
          ], -1)),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("ul", _hoisted_5, [
              _createElementVNode("li", _hoisted_6, [
                _createElementVNode("span", _hoisted_7, [
                  _cache[3] || (_cache[3] = _createElementVNode("b", { class: "bclass" }, "Magasin : ", -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.note_BL?.client?.store), 1)
                ])
              ]),
              _createElementVNode("li", _hoisted_8, [
                _createElementVNode("span", _hoisted_9, [
                  _cache[4] || (_cache[4] = _createElementVNode("b", { class: "bclass" }, "Téléphone : ", -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.note_BL?.client?.phone), 1)
                ])
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("span", _hoisted_10, [
                  _cache[5] || (_cache[5] = _createElementVNode("b", { class: "bclass" }, "Client :", -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.note_BL?.note_customer_name), 1)
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _cache[11] || (_cache[11] = _createElementVNode("div", { class: "card-header" }, [
            _createElementVNode("h5", { class: "mb-0" }, "Information Bon livraison")
          ], -1)),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("ul", _hoisted_14, [
              _createElementVNode("li", null, [
                _createElementVNode("span", _hoisted_15, [
                  _cache[7] || (_cache[7] = _createElementVNode("b", { class: "bclass" }, "Bon de livraison :", -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.note_BL?.note_ref), 1)
                ])
              ]),
              _createElementVNode("li", _hoisted_16, [
                _createElementVNode("span", _hoisted_17, [
                  _cache[8] || (_cache[8] = _createElementVNode("b", { class: "bclass" }, "Date :", -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.getDate(_ctx.note_BL?.created_at)), 1)
                ])
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("span", _hoisted_18, [
                  _cache[9] || (_cache[9] = _createElementVNode("b", { class: "bclass" }, "Colis :", -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.note_BL?.note_total_parcel), 1)
                ])
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("span", _hoisted_19, [
                  _cache[10] || (_cache[10] = _createElementVNode("b", { class: "bclass" }, "Total :", -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.note_BL?.crbt) + " " + _toDisplayString(_ctx.$devis), 1)
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _cache[12] || (_cache[12] = _createElementVNode("hr", null, null, -1)),
      _cache[13] || (_cache[13] = _createElementVNode("div", { class: "col-md-6" }, null, -1)),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filter.searchTerm) = $event)),
                placeholder: "chercher",
                onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showDetails())),
                type: "text",
                class: "form-control",
                onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleInput && _ctx.handleInput(...args)))
              }, null, 544), [
                [_vModelText, _ctx.filter.searchTerm]
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_vue_good_table, {
      columns: _ctx.columnsBL,
      rows: _ctx.colisBL
    }, {
      "table-row": _withCtx((props) => [
        (props.column.field === 'num')
          ? (_openBlock(), _createElementBlock("span", _hoisted_25, [
              _createElementVNode("span", _hoisted_26, _toDisplayString(props.row.originalIndex + 1), 1)
            ]))
          : (props.column.field === 'code')
            ? (_openBlock(), _createElementBlock("b", _hoisted_27, _toDisplayString(props.row.code), 1))
            : (props.column.field === 'status')
              ? (_openBlock(), _createElementBlock("span", _hoisted_28, [
                  (props.row.status == 'IN_PROGRESS')
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: "rounded-pill fs-13 badge text-bg-black custom-badge",
                        style: _normalizeStyle({
            '--dynamic-bg': _ctx.globalStore.globalHelper(props.row.status_second)
              .code_color,
          })
                      }, _toDisplayString(_ctx.globalStore.globalHelper(props.row.status_second).name), 5))
                    : (_openBlock(), _createElementBlock("span", {
                        key: 1,
                        class: "rounded-pill fs-13 badge text-bg-black custom-badge",
                        style: _normalizeStyle({ '--dynamic-bg': props.row.code_color })
                      }, _toDisplayString(props.row.s_name), 5))
                ]))
              : (props.column.field === 'price')
                ? (_openBlock(), _createElementBlock("span", _hoisted_29, [
                    _cache[14] || (_cache[14] = _createElementVNode("b", null, "Adresse : ", -1)),
                    _createTextVNode(" " + _toDisplayString(props.row.address), 1),
                    _cache[15] || (_cache[15] = _createElementVNode("br", null, null, -1)),
                    _cache[16] || (_cache[16] = _createElementVNode("b", null, "Destinataire : ", -1)),
                    _createTextVNode(" " + _toDisplayString(props.row.receiver), 1),
                    _cache[17] || (_cache[17] = _createElementVNode("br", null, null, -1))
                  ]))
                : (props.column.field === 'info')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(props.row.price) + " " + _toDisplayString(_ctx.$devis), 1))
                  : (props.column.field === 'actions' && _ctx.type_e == true)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_31, [
                        (
            props.row.status == 'WAITING_PICKUP' &&
            props.row.reception_note == 0
          )
                          ? (_openBlock(), _createBlock(_component_buttonn, {
                              key: 0,
                              variant: "danger",
                              class: "btn-icon",
                              onClick: ($event: any) => (_ctx.removeColisBL(props.row.id_colis, _ctx.noteBL))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_feather_icon, { icon: "TrashIcon" })
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          : _createCommentVNode("", true)
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(props.formattedRow[props.column.field]), 1))
      ]),
      _: 1
    }, 8, ["columns", "rows"]),
    _createElementVNode("div", _hoisted_33, [
      _createElementVNode("span", _hoisted_34, [
        _cache[18] || (_cache[18] = _createElementVNode("strong", null, "Total :", -1)),
        _createTextVNode(" " + _toDisplayString(_ctx.totalPriceBL.toFixed(2)) + " " + _toDisplayString(_ctx.$devis), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_35, [
      _cache[19] || (_cache[19] = _createElementVNode("div", { class: "col-md-6" }, null, -1)),
      _createElementVNode("div", _hoisted_36, [
        _createVNode(_component_PaginatorContent, {
          pagination: _ctx.filter,
          onPaginate: _ctx.showDetails,
          offset: 9
        }, null, 8, ["pagination", "onPaginate"])
      ])
    ])
  ], 64))
}